export class HamburgerMenu {
    #menu;
    #hamburgerBtn;

    #activeClass = 'js-hamburger-is-opened';

    constructor(menu, hamburgerBtn) {
        if (typeof HamburgerMenu.instance === 'object') return HamburgerMenu.instance;

        if (!(menu instanceof Element) || !(hamburgerBtn instanceof Element)) return;

        this.#menu = menu;
        this.#hamburgerBtn = hamburgerBtn;

        this.#setHandlerOnHamburgerButton();
        this.#setResizeHandler();

        HamburgerMenu.instance = this;
        return this;
    }

    #setHandlerOnHamburgerButton = () => {
        this.#hamburgerBtn.addEventListener('click', (e) => {
            if (document.documentElement.classList.contains(this.#activeClass)) {
                this.close();
            } else {
                this.open();
            }
        });
    };

    #setResizeHandler = () => {
        window.addEventListener('resize', (e) => {
            if (
                window.innerWidth >= 1376 &&
                document.documentElement.classList.contains(this.#activeClass)
            )
                this.close();
        });
    };

    open = () => {
        this.#menu.removeAttribute('inert');
        document.documentElement.classList.add(this.#activeClass);
    };

    close = () => {
        this.#menu.setAttribute('inert', '');
        document.documentElement.classList.remove(this.#activeClass);
    };
}
